import { MdOutlineShare } from "react-icons/md";

export default function ShareButton({ className = "", showLabel = false }) {
  const productUrl = window.location.href;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        const shareData = {
          title: "Check out this product!",
          text: "I found this great product for you!",
          url: productUrl,
        };

        await navigator.share(shareData);
        console.log("Product shared successfully");
      } catch (error) {
        console.error("Error sharing the product:", error);
      }
    } else {
      console.log("Web Share API not supported in this browser.");
    }
  };

  return (
    <button
      className={
        showLabel
          ? `flex items-center px-3 py-2 bg-gray-100 rounded-md text-sm font-medium ${className}`
          : className
      } onClick={handleShare}>
      {showLabel && <span className="mr-2">Share Product</span>}
      <MdOutlineShare className="w-6 h-6" style={{ color: "#000080" }} />
    </button>
  );
}
